<!-- 
    <header-component *ngIf="template == 'mobile'" [color]="'#FCA8A8'" [title]="'NAVIGATION.PROFILE' | translate"></header-component>
 -->
 <ion-content>
    <home-mobile-page *ngIf="template === 'mobile'"></home-mobile-page>
    <home-desktop-page *ngIf="template === 'desktop'"></home-desktop-page>
</ion-content>